import React, { useEffect, useState, useCallback } from 'react'
import ConfiguracionLogic from '../../functions/logic/Configuracion'
import Select from 'react-select'
import SeguridadesLogic from '../../functions/logic/Seguridades'


export default function UsuariosConfig(props) {
    const [numeroIdentificacion, setNumeroIdentificacion] = useState('')
    const [primerNombre, setPrimerNombre] = useState('')
    const [segundoNombre, setSegundoNombre] = useState('')
    const [primerApellido, setPrimerApellido] = useState('')
    const [segundoApellido, setSegundoApellido] = useState('')
    const [codigoUsuario, setCodigousuario] = useState('')
    const [email, setEmail] = useState('')
    const [sexo, setSexo] = useState('')
    const [fechaNacimiento, setFechaNacimiento] = useState('')
    const [esActivo, setEsActivo] = useState('')
    const [rolUser, setRolUSer] = useState('')
    const [empresaId, setEmpresaId] = useState('')
    const [objEmpresa, setObjEmpresa] = useState([])
    const [roles, setRoles] = useState([])
    const [listRoles, setListRoles] = useState([])
    const [roleOptions, setRoles2] = useState([])
    const [spiner, setSpiner] = useState(false)
        

    const [selectedRoles, setSelectedRoles] = useState([])

    const handleRolesChange = (selectedOption) => {
        if (selectedOption && !selectedRoles.includes(selectedOption)) {
            const nuevosSelectedRoles = [...selectedRoles, selectedOption];
            setSelectedRoles(nuevosSelectedRoles);
    
            const nuevoRol = {
                codigoRol: selectedOption.value,
                nombreRol: selectedOption.label,
                estado: 'S',
            };
    
            setListRoles((prevRoles) => {
                const updatedRoles = [...prevRoles, nuevoRol];
    
                // Guardar en localStorage
                localStorage.setItem('rolesSeleccionados', JSON.stringify(updatedRoles));
    
                return updatedRoles;
            });
        }
    };

    // recupera el rol del usuario
const getRolesUser = useCallback(async (page, perPage,codigoUsuario) => {
        setSpiner(true);
        const respRoles = await SeguridadesLogic.rolesByUserExtLogic(page, perPage,codigoUsuario);

        if (respRoles){
            const initialSelectedRolesUsu = (respRoles.data || []).map(rol => ({
                value: rol.Codigo,
                label: rol.Nombre
            }));

            setSelectedRoles(initialSelectedRolesUsu);
                // 2. Crear lista de roles con estado 'S'
    const initialListRoles = initialSelectedRolesUsu.map(rol => ({
        codigoRol: rol.value,
        nombreRol: rol.label,
        estado: 'S'
    }));

    // 3. Setear lista completa
    setListRoles(initialListRoles);

    // 4. Guardar en localStorage
    //localStorage.setItem('rolesSeleccionados', JSON.stringify(initialListRoles));

        };
      


        const localStorageData = localStorage.getItem('rolResp');
        let parsedRoles = [];
    
        if (localStorageData) {
            try {
                const rolesFromStorage = JSON.parse(localStorageData);
                parsedRoles = rolesFromStorage
                    .filter(rol => rol.Codigo && rol.Codigo.trim() !== '')
                    .map(rol => ({
                        value: rol.Codigo,
                        label: rol.Nombre
                    }));
            } catch (error) {
                console.error('Error al parsear roles del localStorage:', error);
            }
        }
    
        // Si no hay roles válidos en localStorage, consultar al backend
        if (parsedRoles.length === 0) {
            const respRoles = await SeguridadesLogic.rolesLogic(page, perPage, '');
            if (respRoles.success) {
                parsedRoles = respRoles.data
                    .filter(roles => roles.Codigo && roles.Codigo.trim() !== '')
                    .map(roles => ({
                        value: roles.Codigo,
                        label: roles.Nombre
                    }));
            }
        }
    
        setRoles2(parsedRoles);
        setSpiner(false);
    }, []);





const getRolesSistema = useCallback(async (page, perPage) => {
        setSpiner(true);
        const respRoles = await SeguridadesLogic.rolesLogic(page, perPage,'');

        if (respRoles){
            const initialSelectedRolesUsu = (respRoles.data || []).map(rol => ({
                value: rol.Codigo,
                label: rol.Nombre
            }));

           // setSelectedRoles(initialSelectedRolesUsu);
                // 2. Crear lista de roles con estado 'S'
    const initialListRoles = initialSelectedRolesUsu.map(rol => ({
        codigoRol: rol.value,
        nombreRol: rol.label,
        estado: 'S'
    }));

    // 3. Setear lista completa
   // setListRoles(initialListRoles);

    // 4. Guardar en localStorage
    //localStorage.setItem('rolesSeleccionados', JSON.stringify(initialListRoles));

        };
      


        const localStorageData = localStorage.getItem('rolResp');
        let parsedRoles = [];
    
        if (localStorageData) {
            try {
                const rolesFromStorage = JSON.parse(localStorageData);
                parsedRoles = rolesFromStorage
                    .filter(rol => rol.Codigo && rol.Codigo.trim() !== '')
                    .map(rol => ({
                        value: rol.Codigo,
                        label: rol.Nombre
                    }));
            } catch (error) {
                console.error('Error al parsear roles del localStorage:', error);
            }
        }
    
        // Si no hay roles válidos en localStorage, consultar al backend
        if (parsedRoles.length === 0) {
            const respRoles = await SeguridadesLogic.rolesLogic(page, perPage, '');
            if (respRoles.success) {
                parsedRoles = respRoles.data
                    .filter(roles => roles.Codigo && roles.Codigo.trim() !== '')
                    .map(roles => ({
                        value: roles.Codigo,
                        label: roles.Nombre
                    }));
            }
        }
    
        setRoles2(parsedRoles);
        setSpiner(false);
    }, []);



    useEffect(() => {
        // Recuper el usuario selecionado para el envio a la props
    const dataUsuario = props?.formData?.data ?? {};

    console.log("---->", dataUsuario);

    if (dataUsuario && dataUsuario.codigo) {
        getRolesUser(1, 1500, dataUsuario.codigo);
    }else{
          getRolesSistema(1, 1500, '');
    }

    }, [getRolesUser,props])


const removeRole = (index) => {
    const removedRole = selectedRoles[index];

    // Visualmente lo eliminas
    const nuevosSelectedRoles = selectedRoles.filter((_, i) => i !== index);
    setSelectedRoles(nuevosSelectedRoles);

    // Cambias su estado en listRoles
    setListRoles((prevRoles) => {
        const updatedRoles = prevRoles.map((role) =>
            role.codigoRol === removedRole.value ? { ...role, estado: 'N' } : role
        );

        // Actualizas también el localStorage con los nuevos estados
        localStorage.setItem('rolesSeleccionados', JSON.stringify(updatedRoles));

        return updatedRoles;
    });
};

    const getEmpresa = useCallback(async (idEmpresa, page, perPage) => {
        const resp = await ConfiguracionLogic.empresasLogic(idEmpresa, page, perPage, '')
        if (resp.success) {
            const areas = resp.data
                .filter(area => area.Nombre && area.Nombre.trim() !== '')
                .map(area => ({
                    value: area.id,
                    label: area.Nombre
                }))
            setObjEmpresa(areas)
        }
    }, [])


    useEffect(() => {
        getEmpresa(0, 1, 100)
        const storedRoles = localStorage.getItem('rolResp');
        if (storedRoles) {
            setRoles(JSON.parse(storedRoles));
        }
        let fechaNacimiento;

        if (localStorage.getItem("userNumIden")) {
            setNumeroIdentificacion(localStorage.getItem("userNumIden"));
            setPrimerNombre(localStorage.getItem("userPNombre"));
            setSegundoNombre(localStorage.getItem("userSNombre"));
            setPrimerApellido(localStorage.getItem("userPApellido"));
            setSegundoApellido(localStorage.getItem("userSApellido"));
            setCodigousuario(localStorage.getItem("UserCodUser"));
            setEmail(localStorage.getItem("userEmail"));
            setSexo(localStorage.getItem("sexoUBI"));
            setEsActivo(localStorage.getItem("estadoUBI"));
            setEmpresaId(localStorage.getItem("empresaUBI"));

            fechaNacimiento = localStorage.getItem("userFNaci");

            if (fechaNacimiento && fechaNacimiento.includes("/")) {
                const [day, month, year] = fechaNacimiento.split("/");
                fechaNacimiento = `${year}-${month}-${day}`;
            }
            setFechaNacimiento(fechaNacimiento);
        } else if (props.formData.data) {
            const datForm = props.formData.data;
            setNumeroIdentificacion(datForm["identificacion"]);
            setPrimerNombre(datForm["primerNombre"]);
            setSegundoNombre(datForm["segundoNombre"]);
            setPrimerApellido(datForm["primerApellido"]);
            setSegundoApellido(datForm["segundoApellido"]);
            setCodigousuario(datForm["codigo"]);
            setEmail(datForm["email"]);
            setSexo(datForm["sexo"]);

            fechaNacimiento = datForm["nacimiento"];

            if (fechaNacimiento.includes("/")) {
                const [day, month, year] = fechaNacimiento.split("/");
                fechaNacimiento = `${year}-${month}-${day}`;
            }
            setFechaNacimiento(fechaNacimiento);
            setEsActivo(datForm["esActivo"]);
            setEmpresaId(datForm["idEmpresa"]);

            localStorage.setItem("userNumIden", datForm["identificacion"]);
            localStorage.setItem("userPNombre", datForm["primerNombre"]);
            localStorage.setItem("userSNombre", datForm["segundoNombre"]);
            localStorage.setItem("userPApellido", datForm["primerApellido"]);
            localStorage.setItem("userSApellido", datForm["segundoApellido"]);
            localStorage.setItem("UserCodUser", datForm["codigo"]);
            localStorage.setItem("userEmail", datForm["email"]);
            localStorage.setItem("sexoUBI", datForm["sexo"]);
            localStorage.setItem("userFNaci", fechaNacimiento);
            localStorage.setItem("estadoUBI", datForm["esActivo"]);
            localStorage.setItem("empresaBUI", datForm["idEmpresa"]);
        }
    }, [props, getEmpresa]);

    const handleNumberChange = (e, setter, storageKey) => {
        const value = e.target.value;
        // Solo permitir números
        if (/^\d*$/.test(value)) {
            setter(value);
            localStorage.setItem(storageKey, value);
        }
    };

    const handleTextChange = (e, setter, storageKey) => {
        const value = e.target.value;
        // Solo permitir letras y espacios
        if (/^[a-zA-Z\s]*$/.test(value)) {
            setter(value);
            localStorage.setItem(storageKey, value);
        }
    };

    const normalChange = (e, setter, storageKey) => {
        const value = e.target.value;
        setter(value);
        localStorage.setItem(storageKey, value);
    };

    return (
        <div className="row justify-content-center">
            <div className="card-body">
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Identificación</label>
                            <input
                                id="identificacion"
                                name="identificacion"
                                maxLength={13}
                                value={numeroIdentificacion}
                                onChange={e => handleNumberChange(e, setNumeroIdentificacion, 'userNumIden')}
                                className="form-control"
                                placeholder="Ingresar identificación"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Código</label>
                            <input
                                id="codigo"
                                name="codigo"
                                maxLength={13}
                                type='text'
                                value={codigoUsuario}
                                onChange={e => normalChange(e, setCodigousuario, 'UserCodUser')}
                                className="form-control"
                                placeholder="Ingresar Codigo Usuario"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Primer Nombre</label>
                            <input
                                id="pNombre"
                                name="pNombre"
                                maxLength={100}
                                type="text"
                                value={primerNombre}
                                onChange={e => handleTextChange(e, setPrimerNombre, 'userPNombre')}
                                className="form-control"
                                placeholder="Ingresar su nombre"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Segundo Nombre</label>
                            <input
                                id="sNombre"
                                name="sNombre"
                                maxLength={100}
                                type="text"
                                value={segundoNombre}
                                onChange={e => handleTextChange(e, setSegundoNombre, 'userSNombre')}
                                className="form-control"
                                placeholder="Ingresar Segundo nombre"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Primer Apellido</label>
                            <input
                                id="pApellido"
                                name="pApellido"
                                maxLength={1000}
                                type="text"
                                value={primerApellido}
                                onChange={e => handleTextChange(e, setPrimerApellido, 'userPApellido')}
                                className="form-control"
                                placeholder="Ingresar Apellido"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Segundo Apellido</label>
                            <input
                                id="sApellido"
                                name="sApellido"
                                maxLength={1000}
                                type="text"
                                value={segundoApellido}
                                onChange={e => handleTextChange(e, setSegundoApellido, 'userSApellido')}
                                className="form-control"
                                placeholder="Ingresar segundo apellido"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Fecha nacimiento</label>
                            <input
                                id="fNacimiento"
                                name="fNacimiento"
                                type="date"
                                value={fechaNacimiento}
                                onChange={e => {
                                    setFechaNacimiento(e.target.value);
                                    localStorage.setItem('userFNaci', e.target.value);
                                }}
                                className="form-control"
                                placeholder="Ingresar fecha de nacimiento"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                id="email"
                                name="email"
                                maxLength={1000}
                                type="text"
                                value={email}
                                onChange={e => {
                                    setEmail(e.target.value);
                                    localStorage.setItem('userEmail', e.target.value);
                                }}
                                className="form-control"
                                placeholder="Ingresar Email"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Sexo</label>
                            <select
                                className="form-control"
                                id="sexo"
                                name="sexo"
                                value={sexo}
                                onChange={e => {
                                    setSexo(e.target.value);
                                    localStorage.setItem('sexoUBI', e.target.value);
                                }}
                            >
                                <option value="">Seleccionar Sexo</option>
                                <option value="M">Masculino</option>
                                <option value="F">Femenino</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Empresa</label>
                            <select
                                className="form-control"
                                name="empresa"
                                id="empresa"
                                value={empresaId}
                                onChange={e => {
                                    setEmpresaId(e.target.value);
                                    localStorage.setItem('empresaUBI', e.target.value);
                                }}
                            >
                                <option value="">Seleccione una empresa</option>
                                {objEmpresa.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Estado</label>
                            <select
                                className="form-control"
                                id="estado"
                                name="estado"
                                value={esActivo}
                                onChange={e => {
                                    setEsActivo(e.target.value);
                                    localStorage.setItem('estadoUBI', e.target.value);
                                }}
                            >
                                <option value="">Seleccionar estado</option>
                                <option value="S">Activo</option>
                                <option value="N">Inactivo</option>
                            </select>
                        </div>
                    </div>
                    
                <div className="col-md-12">
                    <div className="card p-3">
                        <label>Rol</label>
                        {props.editRoles !== "usuarios" && (
                            <>
                                <p>Seleccione rol que desea asociar</p>
                                <Select
                                    disabled={props.editRoles !== "usuarios"}
                                    options={roleOptions}
                                    placeholder="Seleccionar"
                                    onChange={handleRolesChange}
                                    isClearable
                                    menuPortalTarget={document.body} // Mueve el dropdown al body
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                        container: (base) => ({ ...base, width: '100%' }) // Asegura que tome todo el ancho del card
                                    }}
                                />
                            </>
                        )}
                        <div className="mt-3">
                            {selectedRoles.map((role, index) => (
                                <div key={index} className="d-flex align-items-center justify-content-between mb-2">
                                    <span>{role.label}</span>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-danger"
                                        onClick={() => removeRole(index)}
                                        style={{ fontSize: '0.60rem' }}
                                    >
                                        <i className="fas fa-trash-alt" style={{ fontSize: '0.60rem' }}></i>
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                    {/*<div className="col-sm-6">
                        <div className="form-group">
                            <label>Rol</label>
                            <select
                                className="form-control"
                                id="rol"
                                name="rol"
                                value={rolUser}
                                onChange={e => {
                                    setRolUSer(e.target.value);
                                    localStorage.setItem('rolUBI', e.target.value);
                                }}
                            >
                                <option value="">Seleccionar rol</option>
                                {roles.map(rol => (
                                    <option key={rol.id} value={rol.Codigo}>
                                        {rol.Nombre}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>+/}
                    {/*<div className="col-md-12">
                        <div className="card p-3">
                            <label>Rol</label>
                            {
                                props.editRoles != "usuarios" && (
                                    <>
                                    <p>Seleccione rol que desea asociar</p>
                                    <Select
                                        disabled={props.editRoles !== "usuarios"}
                                        options={roleOptions}
                                        placeholder="Seleccionar"
                                        onChange={handleRolesChange}
                                        isClearable
                                    />
                                    </>
                                )
                            }
                        </div>
                    </div>*/}

                </div>
            </div>
        </div>
    )
}
